export const FAQS = [
  {
    q: "Hvad koster et samarbejde med LD Media?",
    a: "Prisen afhænger af hvilke services du har brug for. Vi laver alt fra mindre content-pakker til komplette marketing setups med ads, video og hjemmeside. Book en gratis analyse, så giver vi dig et konkret tilbud baseret på din virksomhed.",
  },
  {
    q: "Hvordan foregår samarbejdet?",
    a: "Vi starter med en gratis 30-minutters strategisamtale, hvor vi forstår din forretning og dine mål. Derefter lægger vi en plan, producerer content og lancerer kampagner. Du har én fast kontaktperson hos os, og vi sender løbende opdateringer.",
  },
  {
    q: "Hvilke virksomheder arbejder I med?",
    a: "Vi arbejder med danske virksomheder af alle størrelser — fra lokale restauranter og barbershops til e-commerce og specialforretninger. Du kan se nogle af vores cases på siden, bl.a. Mr. Fried Chicken, Phonecycle, Dhaba Indian Kitchen, The Old Barber Lounge og Fatbike Eksperten.",
  },
  {
    q: "Kan I hjælpe med både content og annoncer?",
    a: "Ja. Vi laver det hele under ét tag — content creation, video redigering, organic marketing, Meta Ads, Google Ads, TikTok Ads, hjemmesider og SEO. Det betyder hurtigere eksekvering og ingen koordinering mellem flere bureauer.",
  },
  {
    q: "Hvor hurtigt kan vi komme i gang?",
    a: "Som regel kan vi starte inden for 1-2 uger efter første samtale. Hvis du har et akut behov, kan vi ofte få noget i luften endnu hurtigere. Skriv eller ring til os, så finder vi en løsning.",
  },
  {
    q: "Hvad koster marketing for en virksomhed?",
    a: "Marketing-budgetter varierer meget — fra et par tusinde kroner om måneden for små lokale virksomheder, til langt større beløb for virksomheder der skalerer aggressivt. Det vigtigste er ikke størrelsen på budgettet, men hvordan det bruges. Vi tilpasser altid strategi og setup til din virkelighed.",
  },
  {
    q: "Hvordan får man flere kunder online?",
    a: "Flere kunder online kommer typisk fra tre ting: synlighed (folk skal kende dig), tillid (de skal stole på dig) og handling (de skal vide hvad de skal gøre). Vi kombinerer organic content, målrettede annoncer og en stærk hjemmeside for at ramme alle tre.",
  },
  {
    q: "Er Facebook annoncer stadig effektive?",
    a: "Ja, Facebook og Instagram (Meta Ads) er stadig nogle af de mest effektive kanaler for de fleste danske virksomheder. Det handler om at lave gode creatives, ramme den rigtige målgruppe og teste sig frem. Vi bruger ofte Meta Ads som rygraden i vores kampagner.",
  },
  {
    q: "Hvad er forskellen på Google Ads og Facebook Ads?",
    a: "Google Ads fanger folk når de aktivt søger efter en løsning (intent-baseret). Facebook Ads (Meta) viser dine annoncer for folk på baggrund af deres interesser og adfærd (interesse-baseret). De fleste virksomheder får det bedste resultat ved at kombinere begge.",
  },
  {
    q: "Hvordan fungerer leadgenerering?",
    a: "Leadgenerering handler om at få potentielle kunder til at vise interesse — fx ved at udfylde en formular, ringe ind eller booke et møde. Vi bygger setups med annoncer, landing pages og opfølgning, der gør det nemt for kunden at tage det første skridt.",
  },
  {
    q: "Hvad er AI-videoer?",
    a: "AI-videoer er videoer skabt eller redigeret med kunstig intelligens. Det kan være alt fra AI-genererede voice-overs til automatiske redigeringer eller helt nye visuelle koncepter. Hos LD Media bruger vi AI som et værktøj til at producere mere content hurtigere — men kvaliteten styres altid af et menneske.",
  },
  {
    q: "Hvorfor er content marketing vigtigt?",
    a: "Content marketing bygger tillid, synlighed og brand over tid. Det er forskellen på en virksomhed folk kender og stoler på, og en der er usynlig. Godt content gør dine annoncer billigere, din organic vækst stærkere og din SEO bedre — alt sammen samtidig.",
  },
  {
    q: "Hvor ofte bør virksomheder poste på sociale medier?",
    a: "Det afhænger af platform og branche. På TikTok og Instagram Reels giver det mening at poste 3-5 gange om ugen. På Facebook og LinkedIn er 2-3 gange ugentligt ofte fint. Konsistens er vigtigere end frekvens — det er bedre at poste 3 gange om ugen i et år end 7 gange om ugen i en måned.",
  },
  {
    q: "Hvordan får man flere leads?",
    a: "Flere leads kommer fra en kombination af relevant trafik (annoncer + organic), en stærk landing page med et klart tilbud, og hurtig opfølgning. De fleste mister leads fordi de ikke følger op hurtigt nok — vi hjælper med at sætte systemer op, der løser begge dele.",
  },
  {
    q: "Hvordan bygger man et stærkt brand?",
    a: "Et stærkt brand bygges på en klar identitet, konsistent visuel stil, en tydelig stemme og en oplevelse, der matcher det du lover. Det er ikke kun et logo — det er alt det folk føler, når de møder din virksomhed. Vi hjælper med både den visuelle og den strategiske del.",
  },
  {
    q: "Hvad koster en professionel hjemmeside?",
    a: "Priserne varierer fra nogle få tusinde kroner for en simpel landing page, til betydeligt mere for større setups med integrationer og e-commerce. Hos LD Media laver vi konverteringsoptimerede hjemmesider, der ikke kun ser godt ud — men også sælger. Kontakt os for et konkret tilbud.",
  },
  {
    q: "Hvad er SEO?",
    a: "SEO (Search Engine Optimization) er kunsten at få din hjemmeside til at rangere højere på Google, så folk finder dig, når de søger efter det du tilbyder. Det dækker over teknisk optimering, content, keywords og links — og det er en af de bedste langsigtede investeringer en virksomhed kan lave.",
  },
  {
    q: "Hvor lang tid tager SEO?",
    a: "SEO er en langsigtet strategi. De første resultater ses typisk efter 3-6 måneder, og de fulde resultater kommer ofte efter 6-12 måneder. Til gengæld bliver effekten ved at vokse over tid — i modsætning til annoncer, der stopper når du slukker dem.",
  },
  {
    q: "Hvordan kan lokale virksomheder få flere kunder?",
    a: "Lokale virksomheder vinder typisk med lokal SEO (Google Maps + lokale søgninger), målrettede lokale annoncer på Meta og TikTok, og stærkt content der viser jeres lokale tilstedeværelse. Vi har specialiseret os i lokale virksomheder og ved præcis hvad der virker.",
  },
  {
    q: "Hvilke sociale medier er bedst for virksomheder?",
    a: "Det kommer an på din målgruppe. TikTok og Instagram er stærke for visuelle brands og yngre målgrupper. Facebook virker stadig godt for lokale services og lidt ældre målgrupper. LinkedIn er ideel for B2B. Vi hjælper dig med at vælge — og fokusere på de platforme, der faktisk leverer resultater.",
  },
];
